import React from 'react';

import { Apify } from '../Apify';
import API from '../API';
import Butt from '../c/Butt';
import { Container, Col, Row } from 'reactstrap';
import { T } from '../traks';
import { R, A } from '../routes';

const UnsubscribeInner = Apify("/a/unsubscribe")
	.with_query_from_props((props) => ({token: props.token}))
	.with_response_prop("info")
	.with_4xx_prop("err")
	.with_ctl_prop()
.wrap((props) => {

	var about_txt = "";

	const { info, token, err } = props;
	const { Authorized, Unsubscribable } = info;

	const PrefLink = (props) => (
		<A className="ad_blue_link" href="/preferences?p=automail">
		{props.children}
		</A>
	);

	switch (token.split(":")[3]) {
		case "GameStatus":
			about_txt = <T>You're unsubscribing from the emails that show you how your games are developing. Sure you want to risk forgetting to trade when something happens?</T>;
			break;
		case "GameStart":
			about_txt = <T>You're unsubscribing from the email that tell you when a game you're in, starts. Sure you want to risk missing the start of a game?</T>;
			break;
		default:
			about_txt = <T>You're unsubscribing from a service email from Aktiedysten.</T>;
	}

	const footer = (
			<Row className="py-5">
			<Col>
				<PrefLink><T>You can also see and update your email preferences here</T></PrefLink>
			</Col>
		</Row>
	);

	if (err) {
		return <span>ERROR: invalid token</span>;
	} else if (!Unsubscribable) {
		return (
			<Container className="py-5">
				<Row>
					<Col>
						<h2><T>You have been unsubscribed; you will no longer receive this type of email.</T></h2>
					</Col>
				</Row>
				{footer}
			</Container>
		);
	} else if (Authorized) {
		const do_unsub = () => {
			API.post("/a/unsubscribe", {token: props.token}, () => {
				props.ctl.reload();
			});
		};
		return (
			<Container className="py-5">
				<Row>
					<Col className="ad_150pct pb-5">
						{about_txt}
					</Col>
				</Row>
				<Row>
					<Col>
						<Butt className="ad_w_25 py-3" onClick={do_unsub}><h2><T>Unsubscribe</T></h2></Butt>
					</Col>
				</Row>
				{footer}
			</Container>
		);
	} else {
		return (
			<Container className="py-5">
				<Row>
					<Col className="ad_150pct pb-5">
						<h2><T>The unsubscribe link is no longer valid, but you can always <PrefLink>log in and update your email preferences</PrefLink></T></h2>
					</Col>
				</Row>
			</Container>
		);
	}
});

const Unsubscribe = (props) => {
	return <UnsubscribeInner token={R.get_arg("t")}/>
};

export default Unsubscribe;



// WEBPACK FOOTER //
// ./src/p/Unsubscribe.js